// Shared API client to centralize fetch and loading state

import { modalOpenMedical, setLoading } from "../Redux/LoadingRedux";
import toast from "react-hot-toast";
import { getValidAccessToken } from "../Services/oauthServices";

export async function apiFetch(dispatch, url, options = {}) {
  try {
    dispatch(setLoading(true));

    const token = await getValidAccessToken();

    // Detect FormData
    const isFormData = options.body instanceof FormData;

    const mergedOptions = {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        ...(options.headers || {}),
      },
    };

    const response = await fetch(url, mergedOptions);
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      const msg = data?.message || "Request failed";

      let errs = [];
      if (Array.isArray(data?.errors?.message)) {
        errs = data.errors.message;
      } else if (data?.data && typeof data.data === "object") {
        errs = Object.values(data.data).map((item) => item.message);
      } else if (typeof data?.error === "string") {
        errs = [data.error];
      } else if (data?.error?.message) {
        errs = [data.error.message];
      }

      dispatch(
        modalOpenMedical({
          open: true,
          message: msg,
          errors: errs,
        }),
      );

      return {
        success: false,
        message: msg,
        errors: errs,
        status: response.status,
      };
    }
    if (data && data.success === false) {
      const msg = data.message || "Validation Failed";

      let errs = [];

      if (data?.data && typeof data.data === "object") {
        errs = Object.values(data.data).map((item) => item.message);
      }

      dispatch(
        modalOpenMedical({
          open: true,
          message: msg,
          errors: errs,
        }),
      );

      return data;
    }

    return data;
  } catch (err) {
    dispatch(
      modalOpenMedical({
        open: true,
        message: err.message || "Something went wrong, please try again",
      }),
    );

    return { success: false, error: err.message };
  } finally {
    dispatch(setLoading(false));
  }
}
